import React, { useState, useEffect } from "react";
import clinicbookingService from "../../../../../services/clinicbooking.service";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";

import { useParams } from "react-router-dom";

const AppointmentType = ({ appt, getAllApptType }) => {
  const [edit, setEdit] = useState(false);
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: appt,
  });

  const toogleEdit = () => {
    setEdit(!edit);
  };

  const onSubmit = (data) => {
    clinicbookingService
      .addUpdateBookingType(data.clinicId, data)
      .then((res) => {
        getAllApptType();
        toast.success("Updated Successfully", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      })
      .catch((err) => {
        console.log(err);
        toast.error("Error While Updating", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      });
  };

  const handleDelete = (bookingtype) => {
    clinicbookingService
      .deleteBookingType(bookingtype.clinicId, bookingtype.id)
      .then((res) => {
        getAllApptType();
        toast.success("Deleted Appointment Type", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      })
      .catch((err) => {
        toast.error("Error while Deleting", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        console.log(err);
      });
  };

  return (
    <>
      {edit ? (
        <>
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="row mb-2 mt-3 p-2 bg-light rounded"
          >
            <div className="col-1">{appt.id}</div>
            <div className="col-4">
              <input
                type="text"
                className="form-control"
                {...register("apptType")}
              />
            </div>
            <div className="col-2">
              <input
                type="text"
                className="form-control"
                {...register("timeSlot")}
              />
            </div>
            <div className="col-3">
              <select {...register("isActive")} className="form-select">
                <option value="1">Active</option>
                <option value="0">InActive</option>
              </select>
            </div>
            <div className="col-2">
              <button className="btn btn-sm btn-info me-2" type="submit">
                <i className="bi bi-floppy"></i>
              </button>
            </div>
          </form>
          <div className="d-flex justify-content-center mb-3 mt-3">
            <button className="btn btn-sm btn-secondary" onClick={toogleEdit}>
              <i className="bi bi-x-square"></i> Cancel
            </button>
          </div>
        </>
      ) : (
        <div className="row mb-2" key={appt.id}>
          <div className="col-1">{appt.id}</div>
          <div className="col-4">{appt.apptType}</div>
          <div className="col-2">{appt.timeSlot}</div>
          <div className="col-2">
            {appt.isActive === 1 ? "Active" : "Inactive"}
          </div>
          <div className="col-3">
            <button className="btn btn-sm btn-info me-2" onClick={toogleEdit}>
              <i className="bi bi-pencil-square"></i>
            </button>
            <button
              className="btn btn-sm btn-danger"
              onClick={() => handleDelete(appt)}
            >
              <i className="bi bi-trash"></i>
            </button>
          </div>
        </div>
      )}
    </>
  );
};


function AddBookingType() {
  const [apptType, setApptType] = useState([]);
  const { clinicId } = useParams();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();
  useEffect(() => {
    getAllApptType();
  }, []);

  const getAllApptType = () => {
    clinicbookingService
      .getAllApptType(clinicId)
      .then((res) => {
        setApptType(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const onSubmit = (data) => {
    let newData = { ...data };
    newData["clinicID"] = clinicId;
    clinicbookingService
      .addUpdateBookingType(clinicId, newData)
      .then((res) => {
        toast.success("Added New Type", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        getAllApptType();
      })
      .catch((err) => {
        toast.error("Error while Adding Type", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        console.log(err);
      });
  };
  return (
    <div className="row">
      <div className="col-7">
        <div className="container m-2">
          <div className="row">
            <div className="col-1">Id</div>
            <div className="col-4">Type</div>
            <div className="col-2">TimeSlot</div>
            <div className="col-2">isActive</div>
            <div className="col-3"></div>
          </div>
          <hr />
          {apptType &&
            apptType.map((appt) => {
              return (
                <AppointmentType
                  key={appt.id}
                  appt={appt}
                  getAllApptType={getAllApptType}
                />
              );
            })}
        </div>
      </div>
      <div className="col-5">
        <div className="card mt-3">
          <div className="card-body">
            <div className="card-header">Add New </div>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="form-group mb-2">
                <label htmlFor="" className="form-label">
                  Type
                </label>
                <input
                  type="text"
                  {...register("apptType")}
                  className="form-control"
                />
              </div>
              <div className="form-group mb-2">
                <label htmlFor="" className="form-label">
                  Timeslot
                </label>
                <input
                  type="text"
                  {...register("timeSlot")}
                  className="form-control"
                />
              </div>
              <div className="form-group mb-2">
                <label htmlFor="" className="form-label">
                  Status
                </label>
                <select {...register("isActive")} className="form-select">
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                </select>
              </div>
              <button className="btn btn-success btn-sm" type="submit">
                Save
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddBookingType;
